export default __webpack_public_path__ + "static/media/image.entry-labs-pvt-ltd.4ae51d5d.png";